export var unitOfAnalysis = {
    name: 'Unit of analysis',
    id: 'unitOfAnalysis',
    depth: 2,
    enableToInclueOtherTagToTopLevel: true,
    tags: [
        {
            name: 'Genes',
            id: 'R4sex6'
        },
        {
            name: 'Molecules',
            id: 'R5aKhi'
        },
        {
            name: 'Cells',
            id: 'tC8qFG'
        },
        {
            name: 'Circuits',
            id: 'Zn5P3v'
        },
        {
            name: 'Physiology',
            id: 'G9pLbQ'
        },
        {
            name: 'Behavior',
            id: 'Z8uK5p'
        },
        {
            name: 'Self-Report',
            id: 'w3FcQW'
        },
        {
            name: 'Paradigms',
            id: 'A9eVQ2'
        },
        {
            name: 'Others',
            id: 'e4P258',
            children: [
                {
                    name: 'Unspecified',
                    id: 'Uz7D2S'
                }
            ]
        }
    ]
};
